import { createApi } from '@reduxjs/toolkit/query/react'
import { customFetchBaseQuery } from '../app/baseQuery'
import type {
  FindClinicsByIdsRequest,
  FindClinicsByIdsResponse,
} from '../../types/patient-api-gateway/api/patient/v1/patient_gateway_service'

export const clinicApi = createApi({
  reducerPath: 'clinicApi',
  baseQuery: customFetchBaseQuery,
  tagTypes: ['Clinic'],
  endpoints: (builder) => ({
    findClinicsByIds: builder.query<
      FindClinicsByIdsResponse,
      { clinicIds: string[] }
    >({
      query: ({ clinicIds }) => ({
        url: '/api.patient.v1.PatientGatewayService/FindClinicsByIds',
        method: 'POST',
        body: { ids: clinicIds } satisfies FindClinicsByIdsRequest,
      }),
      providesTags: ['Clinic'],
      keepUnusedDataFor: 60,
    }),
  }),
})

export const { useFindClinicsByIdsQuery } = clinicApi
